
import { ActionTypes } from 'store/constants';

export const createSlides = (returnPayload) => ({
  type: ActionTypes.slides.create_slide,
  payload: returnPayload,
});

export const getAllSlides = (returnPayload) => ({
  type: ActionTypes.slides.get_slides,
  payload: returnPayload,
});

export const delteSlide = (returnPayload) => ({
  type: ActionTypes.slides.delete_slide,
  payload: returnPayload,
});

export const delteEbookSlide = (returnPayload) => ({
  type: ActionTypes.slides.delete_ebook_slide,
  payload: returnPayload,
});
export const setSlides = (returnPayload) => ({
  type: ActionTypes.slides.set_slides,
  payload: returnPayload,
});

export const openSlideWidgetAction = (returnPayload) => ({
  type: ActionTypes.slides.open_widget,
  payload: returnPayload,
});




